import { useContext, useState } from "react";
import { AppImage } from "@/src/components/NextImage";
import { useSnapshot } from "valtio";
import { cn } from "utils";
import log from "logbeacon";
import { OspApiClientContext } from "@features";
import { rootStore } from "@store";
import { useLoginModalProvider } from "@hooks";

interface CollectionButtonProps {
  defaultSelected?: boolean;
  chainId?: string;
  address?: string;
  onCollectionChange?: (isSelected: boolean) => void;
  children?: React.ReactNode;
  className?: string;
  callback?: () => void;
}

export const CollectionButton = ({
  defaultSelected = false,
  chainId,
  address,
  onCollectionChange,
  children,
  className,
  callback,
}: CollectionButtonProps) => {
  const { open } = useLoginModalProvider();
  const [isSelected, setIsSelected] = useState(defaultSelected);
  const { openApi } = useContext(OspApiClientContext);
  const { isLoggedIn } = useSnapshot(rootStore.login);

  const handleClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    await onCollect(e);
    callback?.();
  };

  const onCollect = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (!isLoggedIn) {
      open?.();
      return;
    }
    try {
      if (!openApi) {
        return;
      }

      setIsSelected(!isSelected);
      if (isSelected) {
        await openApi.tokenseek.deleteTokenReaction({
          chain_id: chainId,
          address,
        });
      } else {
        await openApi.tokenseek.addTokenReaction({
          chain_id: chainId,
          address,
        });
      }

      onCollectionChange?.(!isSelected);
    } catch (error) {
      log.error("[文案]Failed to toggle collection:", error);
    }
  };
  const Collection = "/assets/images/Watchlist-yellow.webp";
  const UnCollection = "/assets/images/Watchlist-white.webp";

  return (
    <button
      aria-label="Collection Button"
      data-openreplay-label="Collection Button Button"
      id="btn-collection-button"
      type="button"
      onClick={handleClick}
      className={cn(className, "min-w-[18px]")}
    >
      <span data-openreplay-label="CollectionButton · span" onClick={onCollect}>
        <AppImage
          src={isSelected ? Collection : UnCollection}
          alt="collection-icon"
          width={18}
          height={16}
        />
      </span>
      {children}
    </button>
  );
};
